import { render, staticRenderFns } from "./CreateBusiness.vue?vue&type=template&id=f071d5c8&scoped=true&"
import script from "./CreateBusiness.vue?vue&type=script&lang=ts&"
export * from "./CreateBusiness.vue?vue&type=script&lang=ts&"
import style0 from "./CreateBusiness.vue?vue&type=style&index=0&id=f071d5c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f071d5c8",
  null
  
)

export default component.exports